import React from 'react';
import { useTranslation } from 'react-i18next';

export const LocationCondition: React.FC = () => {
  const { t } = useTranslation('common');

  return <p>{t('dialogWorkInProgress.header')}</p>;
};
